/**
 * SearchResult class
 * 
 * Represents a game result from BGG search API.
 */
class SearchResult {
    constructor(objectid, name, yearpublished, type) {
        this.objectid = objectid;
        this.name = name;
        this.yearpublished = yearpublished;
        this.type = type;
    }

    /**
     * Create a SearchResult from API response data
     * @param {Object} data - Raw API data
     * @returns {SearchResult}
     */
    static fromApiResponse(data) {
        return new SearchResult(
            data.objectid,
            data.name,
            data.yearpublished,
            data.type || 'boardgame'
        );
    }

    /**
     * Get the BGG URL for this search result
     * @returns {string}
     */
    getBggUrl() {
        return `https://boardgamegeek.com/boardgame/${this.objectid}`;
    }
}

export default SearchResult;